import type { DocumentData } from "firebase/firestore";
import BaseApi from "../core/BaseApi";
import FeedbackModel, { type FeedbackModelData } from "./FeedbackModel";

export default class FeedbackApi extends BaseApi<
  FeedbackModel,
  FeedbackModelData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}feedback`;
  }

  get store() {
    return this.stores.feedbackStore;
  }

  fromFirestore(res: DocumentData): FeedbackModel {
    return new FeedbackModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
